import React from 'react';
import { IconButton } from '../IconButton/IconButton';
import { GrowthIcon } from './GrowthIcon';

export interface GrowthDashboardTopBarActionsProps {
  saveVisible?: boolean;
  saveDisabled?: boolean;
  saveLoading?: boolean;
  dirtyCount?: number;
  onSave?: () => void;
  onDiscard?: () => void;
}

export function GrowthDashboardTopBarActions({
  saveVisible = false,
  saveDisabled = false,
  saveLoading = false,
  dirtyCount = 0,
  onSave,
  onDiscard,
}: GrowthDashboardTopBarActionsProps = {}) {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-3">
      {saveVisible ? (
        <>
          {dirtyCount > 0 ? (
            <span className="text-[12.5px] text-[var(--ink-3)]">
              {dirtyCount} unsaved {dirtyCount === 1 ? 'change' : 'changes'}
            </span>
          ) : null}
          {dirtyCount > 0 ? (
            <button
              type="button"
              onClick={() => onDiscard?.()}
              disabled={saveDisabled || saveLoading}
              className="inline-flex h-[34px] cursor-pointer items-center rounded-[10px] border border-[var(--cream-2)] bg-[var(--cream-1)] px-4 text-[13px] font-medium text-[var(--ink-2)] disabled:cursor-not-allowed disabled:opacity-60"
            >
              Discard
            </button>
          ) : null}
          <button
            type="button"
            onClick={() => onSave?.()}
            disabled={saveDisabled || saveLoading}
            className="inline-flex h-[34px] cursor-pointer items-center rounded-[10px] border border-[var(--success)] bg-[var(--success)] px-4 text-[13px] font-semibold text-[var(--cream-1)] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {saveLoading ? 'Saving…' : 'Save Changes'}
          </button>
          <span className="h-[22px] w-px bg-[var(--cream-2)]" />
        </>
      ) : null}
      <IconButton
        icon="refresh"
        size={34}
        label="Refresh"
        className="rounded-[10px] border border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--cream-0)]"
      />
      <IconButton
        icon="bell"
        size={34}
        label="Notifications"
        className="rounded-[10px] border border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-1)] hover:bg-[var(--cream-0)]"
      />
      <span className="h-[22px] w-px bg-[var(--cream-2)]" />
      <button
        type="button"
        title="Apps"
        className="inline-flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-full border border-[var(--cream-2)] bg-[var(--cream-1)] text-[var(--ink-2)]"
      >
        <GrowthIcon kind="appgrid" size={18} />
      </button>
      <span className="inline-flex h-8 items-center gap-[7px] rounded-[var(--r-pill)] border border-[var(--cream-2)] bg-[var(--cream-1)] px-3">
        <span
          className="h-[7px] w-[7px] rounded-full shadow-[0_0_7px_var(--growth-accent,var(--info))]"
          style={{ background: 'var(--growth-accent, var(--info))' }}
        />
        <span className="text-xs font-bold tracking-[0.06em] text-[var(--ink-1)]">AUTOPILOT</span>
      </span>
    </div>
  );
}
